import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EstimationDetailEvent } from '@rivethealth/data/estimation-detail-event';
import {
  PatientEstimation,
  TransactionParameters,
} from '@rivethealth/data/patient-estimation';
import { SavedCard } from '@rivethealth/data/payment-transaction';
import { CellStore } from './cell';
import { API_URL } from './common';

@Injectable({ providedIn: 'root' })
export class PatientEstimationService {
  constructor(
    @Inject(API_URL) private readonly apiUrl: string,
    private readonly http: HttpClient,
    private readonly cellStore: CellStore,
  ) {}

  getPatientEstimationLogo(jwt: string) {
    return `${
      this.cellStore.getCellUrl() || this.apiUrl
    }/patient-estimation/logo?Authorization=${encodeURIComponent(
      `Bearer ${jwt}`,
    )}`;
  }

  get(jwt: string) {
    return this.http.get<PatientEstimation>(
      `${this.apiUrl}/patient-estimation?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
    );
  }

  pdfUrl(jwt: string) {
    return `${
      this.cellStore.getCellUrl() || this.apiUrl
    }/patient-estimation/pdf?Authorization=${encodeURIComponent(
      `Bearer ${jwt}`,
    )}`;
  }

  markDownloaded(jwt: string) {
    return this.http.post(
      `${
        this.apiUrl
      }/patient-estimation/markDownloaded?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
      {},
    );
  }

  patientEmail(jwt: string) {
    return this.http.get<{ email: string | null }>(
      `${
        this.apiUrl
      }/patient-estimation/email?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
    );
  }

  processTransaction(jwt: string, params: TransactionParameters) {
    return this.http.post(
      `${
        this.apiUrl
      }/patient-estimation/transaction?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
      params,
    );
  }

  getPatientCreditCards(jwt: string) {
    return this.http.get<SavedCard[]>(
      `${
        this.apiUrl
      }/patient-estimation/creditCards?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
    );
  }

  recordEstimationActivityEvent(jwt: string, event: EstimationDetailEvent) {
    return this.http.post<void>(
      `${
        this.apiUrl
      }/estimation-activity/patient?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
      event,
    );
  }

  getPatientAccountId(jwt: string) {
    return this.http.get<number>(
      `${
        this.apiUrl
      }/patient-estimation/accountId?Authorization=${encodeURIComponent(
        `Bearer ${jwt}`,
      )}`,
    );
  }
}
